import * as React from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import { cn } from '@/lib/utils'

/**
 * Figma (node 195:1621 — Popover):
 * Container: bg-popover, border border-border (1px), rounded-lg (10px), p-2.5 (10px),
 *   shadow-md, w-80 (320px), flex flex-col gap-2.5 (10px)
 * Header: flex flex-col gap-0.5 (2px)
 *   Title: text-sm font-medium leading-5 text-popover-foreground
 *   Description: text-sm font-normal leading-5 text-muted-foreground
 * Animations: fade + zoom + slide per side
 */

const IntuiPopover = PopoverPrimitive.Root

const IntuiPopoverTrigger = PopoverPrimitive.Trigger

const IntuiPopoverClose = PopoverPrimitive.Close

const IntuiPopoverAnchor = PopoverPrimitive.Anchor

export interface IntuiPopoverContentProps
  extends React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> {
  container?: HTMLElement | null
}

const IntuiPopoverContent = React.forwardRef<
  React.ComponentRef<typeof PopoverPrimitive.Content>,
  IntuiPopoverContentProps
>(({ className, align = 'center', sideOffset = 4, container, ...props }, ref) => (
  <PopoverPrimitive.Portal container={container}>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'z-[999999] w-80 rounded-lg border border-border bg-popover p-2.5',
        'flex flex-col gap-2.5',
        'text-popover-foreground shadow-md outline-none',
        'data-[state=open]:animate-in data-[state=closed]:animate-out',
        'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
        'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
        'data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2',
        'data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        className
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
))
IntuiPopoverContent.displayName = 'IntuiPopoverContent'

export {
  IntuiPopover,
  IntuiPopoverTrigger,
  IntuiPopoverContent,
  IntuiPopoverClose,
  IntuiPopoverAnchor,
}
